import { FC, isValidElement } from 'react';
import { Tooltip, tooltipClasses, useTheme } from '@mui/material';
import { COLORS } from 'services/constants/colors';
import { TEasTooltipProps } from './types';

export const EasTooltip: FC<TEasTooltipProps> = ({
	children,
	type = 'default',
	slotProps,
	...rest
}) => {
	const theme = useTheme();
	const isWarning = type === 'warning';
	const backgroundColor = isWarning ? theme.palette.warning.main : COLORS.TOOLTIP_BG;
	const textColor = isWarning ? theme.palette.warning.contrastText : COLORS.TOOLTIP_COLOR;
	const borderColor = isWarning ? theme.palette.warning.dark : COLORS.BORDER;
	// A disabled element does not fire events, so the tooltip needs a wrapper to listen to them.
	const isDisabledChild =
		isValidElement<{ disabled?: boolean }>(children) && !!children.props.disabled;

	return (
		<Tooltip
			{...rest}
			slotProps={{
				...slotProps,
				tooltip: {
					...slotProps?.tooltip,
					sx: {
						backgroundColor: `${backgroundColor}!important`,
						color: textColor,
						border: `1px solid ${borderColor}`,
						boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
						fontSize: '0.8rem',
						[`&.${tooltipClasses.tooltipPlacementTop}`]: {
							marginBottom: '8px',
						},
						...((slotProps?.tooltip as Record<string, unknown>)?.sx as Record<string, unknown>),
					},
				},
				arrow: {
					...slotProps?.arrow,
					sx: {
						color: backgroundColor,
						'&::before': {
							border: `1px solid ${borderColor}`,
						},
						...((slotProps?.arrow as Record<string, unknown>)?.sx as Record<string, unknown>),
					},
				},
			}}
		>
			{isDisabledChild ? <span>{children}</span> : children}
		</Tooltip>
	);
};
